import React from "react";

const Field = ({
  label,
  unit,
  fixed = false,
  children,
}: {
  label: string;
  unit?: string;
  fixed?: boolean;
  children: React.ReactNode;
}) => (
  <div className={`te-field${fixed ? " te-field--fixed" : ""}`}>
    <div className="te-field-label">
      <span>{label}</span>
      {unit && <span className="te-field-unit">{unit}</span>}
      {fixed && (
        <span className="te-fixed-indicator">
          <i className="pi pi-lock" />
          fixed
        </span>
      )}
    </div>
    <div className="te-field-input">{children}</div>
  </div>
);

export default Field;
